/**
 * O aviso de que a contingência da SENATRAN pode ter mudado (`R-06`, ADR-077).
 *
 * Quem muda é uma ação — o envio que ficou na fila, o *Tentar agora* —; quem mostra é a faixa do
 * topo e a tela SENATRAN. A ação avisa, as duas releem — sem esperar os 30 segundos da faixa.
 */
export const EVENTO_DA_CONTINGENCIA = "cockpit:contingencia";

export function avisarQueAContingenciaPodeTerMudado(): void {
  window.dispatchEvent(new Event(EVENTO_DA_CONTINGENCIA));
}
